import { toast } from 'react-toastify';

import { ConfirmModal } from '~/components/ui';
import type { MlsRow } from '~/components/Constants/mlsConstants';
import { mlsErrorText, mlsKeyFor } from '~/components/pages/mls/components/feedActions';
import { useDeleteMlsMutation } from '~/modules/query/mls';

interface MlsDeleteConfirmProps {
  feed: MlsRow | null;
  onClose: () => void;
  /** Runs after a successful delete (the record page leaves for the list). */
  onDeleted?: () => void;
}

export default function MlsDeleteConfirm({ feed, onClose, onDeleted }: MlsDeleteConfirmProps) {
  const [deleteMls] = useDeleteMlsMutation();

  const confirm = () =>
    deleteMls(mlsKeyFor(feed ?? undefined))
      .unwrap()
      .then(() => {
        toast.success('Feed deleted');
        onDeleted?.();
      })
      .catch((err) => toast.error(mlsErrorText(err)))
      .finally(onClose);

  return (
    <ConfirmModal
      isOpen={feed !== null}
      variant="danger"
      title="Delete feed"
      message={
        <>
          Delete the feed <strong>{feed?.name ?? feed?._id}</strong>?
        </>
      }
      dangerNote="This permanently deletes the feed configuration and its MLS config. It cannot be undone."
      confirmLabel="Delete feed"
      testId="feeds-delete-confirm"
      onConfirm={confirm}
      onClose={onClose}
    />
  );
}
